<!-- Card Header Start-->

<div class="lg:ps-10 pt-4 pb-1 pe-4 ps-4">
  <div class="flex justify-end">
    <button class="size-5 rounded-md flex justify-center items-center outline-0 hover:bg-black cursor-pointer group"
            [mat-dialog-close]="true" (click)="cancel()" matTooltip="Close">
      <!-- Gray cross (default) -->
      <img src="../../../../../../assets/images/icons/global/popup-cross.svg" class="block group-hover:hidden"
           alt="gray cross" height="10" width="10">

      <!-- White cross (on hover) -->
      <img src="../../../../../../assets/images/icons/global/popup-cross-white.svg" class="hidden group-hover:block"
           alt="white cross" height="10" width="10">
    </button>
  </div>
  <div class="lg:pe-6 pe-4 lg:mb-5 mb-1">
    <h1 class="font-medium text-[18px] leading-6 text-[#15191E]">Add Team Member Hours</h1>
    <p class="text-sm font-normal text-[#60646C] lg:mt-3 mt-1">Add estimated hours for a selected team
      member.</p>
  </div>

</div>
<!-- Card Header End-->

<div class="mat-typography !pt-1 lg:!pb-8 lg:!px-10  !pb-4 !px-4">
  <div class="grid grid-cols-3 lg:gap-[14px] gap-2">

    <div class="col-span-3">
      <label class="field-label" for="Assignee">Team Member Name</label>
<app-select-avatar id="Assignee"
                  [placeHolder]="'Assignee'"
                  [label]="'fullName'"
                  [pageResult]="userService.users$ | async"
                  (clear)="userService.fetchUsers$(usersFilter, $event)"
                  (scrollEnd)="userService.fetchNextUsers$(usersFilter, $event)"
                  (search)="userService.searchInUsers$(usersFilter, $event)"
                  (selectionChanged)="onChangeUserSelection($event)"
                   [getAllDatainField]="true"
                  [showRefresh]="false">
            </app-select-avatar>
    </div>

    <div [ngClass]="estimatedHoursOnly? 'col-span-3': 'col-span-3 lg:col-span-1' ">
      <label class="field-label" for="EstimatedHours">Estimated Hours</label>
      <input type="text"
             class="input-field w-full [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
             id="EstimatedHours" placeholder="0"
             (input)="onChangeEstimatedHours($event, 0)"
                          [maxLength]="6">
    </div>

    <div *ngIf="estimatedHoursOnly === false" class="lg:col-span-1 col-span-3">
      <label class="field-label" for="RegularHours">Regular Hours</label>
      <input type="text"
             class="input-field w-full [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
             id="RegularHours" placeholder="0"
             (input)="onChangeRegularHours($event, 0)"
                          [maxLength]="6">
    </div>

    <div *ngIf="estimatedHoursOnly === false" class="lg:col-span-1 col-span-3">
      <label class="field-label" for="OvertimeHours">Overtime Hours</label>
      <input type="text"
             class="input-field w-full [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
             id="OvertimeHours" placeholder="0"
             (input)="onChangeOverTimeHours($event, 0)"
                          [maxLength]="6">
    </div>

  </div>

</div>

<mat-dialog-actions class="lg:!px-10 lg:!pb-8 lg:!pt-0  !px-4 !pb-4 !pt-0">
  <div class="flex-1">
    <bk-button 
      variant="primary"
      label="Add Team Member"
      size="sm"
      [loading]="loading" 
      [disabled]="!isEnableSaveButton" 
      (clicked)="onSubmitLaborHours()"  
      buttonClass="text-white bg-[#141414] w-full !py-[5px] rounded-md">
    </bk-button>
  </div>
</mat-dialog-actions>
